import { render, staticRenderFns } from "./PriceOptimization.vue?vue&type=template&id=8b12e7c2"
import script from "./PriceOptimization.vue?vue&type=script&lang=js"
export * from "./PriceOptimization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports